// components/Events/Events.js
import React from "react";
import "./events.css";
import { Link } from "react-router-dom";
//import news from "../../assets/newsdat";
import news from "../../assets/news/newsdata";
import EventCard from "../eventcard/EventCard";

function Events() {
  return (
    <div className="event-section">
      <div className="container">
        <h2 className="sub-heading">ข่าวสาร/กิจกรรมล่าสุด</h2>
        <div className="events-grid">
          {news.slice(0, 3).map((item) => (
            <EventCard
              key={item.id}
              id={item.id}
              image={item.image}
              name={item.name}
              date={item.data}
              context={item.context}
            />
          ))}
        </div>
        <div className="events-footer center-text">
          <Link to="/news-events">
            <p>all news</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Events;
